import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationArrow } from '@fortawesome/free-solid-svg-icons';

// CSS styles
const useStyles = makeStyles(() => ({
  icon: {
    transition: 'transform 0.3s ease-in-out',
    fontSize: 16,
    marginRight: 8,
  },
  container: {
    display: 'flex',
    alignItems: 'center',
  },
}));

// Convert degree to direction
const getCardinalDirection = (angle) => {
  const directions = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'];
  const index = Math.round(angle / 45) % 8;
  return directions[index];
};

// Component
const WindDirectionIcon = ({ degree }) => {
  const classes = useStyles();
  const direction = getCardinalDirection(degree);

  return (
    <div className={classes.container}>
      <FontAwesomeIcon
        icon={faLocationArrow}
        className={classes.icon}
        style={{ transform: `rotate(${degree}deg)` }}
      />
      <Typography variant="body3">{direction}</Typography>
    </div>
  );
};

export default WindDirectionIcon;

